// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a55051d","239":"305adb24","453":"9e66a027","667":"a191d0dd"}[chunkId] + ".chunk.js";
};